"use strict";

/* eslint-disable */
// This file is generated by the generateThemesRegistry script

/**
 * This is constant variable that the themes used
 * type {infoThemes[]}
 */
var cxuiversion = "@cx/ui-5.1.4";
module.exports = {
  cxuiversion: cxuiversion
};